import "./utils/index";

require("./proto");

require("./jquery");

require("bootstrap");

window.axios = require("axios");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
